import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitTaskGroupModel, IUnitTaskGroupsSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS_INFINITE = (model?: IUnitTaskGroupsSearchParamsModel) =>
  ['searchUnitTaskGroupsInfinite', model?.groupName, model?.status, model?.taskType, model?.archived, model?.orderBy].filter(Boolean)

export const searchUnitTaskGroupsInfinite = async (model: IUnitTaskGroupsSearchParamsModel): Promise<IUnitTaskGroupModel[]> =>
  axios.post('/management/UnitProgramTask/SearchTaskGroups', model).then((res) => res.data?.data)

type Props = {
  enabled: boolean
  model: IUnitTaskGroupsSearchParamsModel
}

export const useManagementSearchUnitTaskGroupsInfinite = ({ enabled = true, model }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    enabled,
    staleTime: 0,
    gcTime: 0,
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS_INFINITE(model),
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => searchUnitTaskGroupsInfinite({ ...model, skip: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < model.take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_GROUPS_INFINITE() })
    },
    []
  )

  return {
    isLoading,
    isFetching,
    isRefetching,
    isError,
    data,
    refetch,
    fetchNextPage,
    hasNextPage
  }
}
